"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderHero = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const component_context_1 = require("../context/component.context");
const header_base_1 = require("../header/header-base");
const component_1 = require("../header-back/component");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.HeaderHero>
 *
 * Блок с фоном. Ведёт себя как часть контента. Размещается на месте шапки.
 */
const HeaderHero = ({ bgImageUrl, children, className, dataTestId, hasCloser = true, subtitle, title, onBackClick, }) => {
    const { isMobile, isResponsive } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    const style = (0, react_1.useMemo)(() => ({
        backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : 'none',
    }), [bgImageUrl]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(index_module_css_1.default.component, className), "data-test-id": dataTestId, children: [(0, jsx_runtime_1.jsx)("div", { className: index_module_css_1.default.bgBlock, role: 'img', style: style }), onBackClick ? ((0, jsx_runtime_1.jsx)(component_1.HeaderBack, { hasCloser: hasCloser, onBackClick: onBackClick, subtitle: subtitle, title: title, transparent: true, sticky: false })) : ((0, jsx_runtime_1.jsx)(header_base_1.HeaderBase, { className: index_module_css_1.default.header, hasCloser: hasCloser, sticky: false, subtitle: subtitle, title: title })), (0, jsx_runtime_1.jsx)(side_panel_1.SidePanel.Content, { className: (0, classnames_1.default)(index_module_css_1.default.content, platformStyles), children: children })] }));
};
exports.HeaderHero = HeaderHero;
